module.exports = __webpack_public_path__ + "img/pic3.33f30376.png";